export enum WebportalEvent {
    OrderFlexCards = 'orderFlexCards',
    PaymentFailed = 'paymentFailed',
    FloatLabels = 'floatLabels',
    GatewayProblem = 'gatewayProblem',
    UserSuspended = 'userSuspended',
    UserUnsuspended = 'userUnsuspended',
    InvoicePaid = 'invoicePaid',
    CreateFilespace = 'createFilespace',
    FilespaceCreated = 'filespaceCreated',
    FilespaceProvisioning = 'filespaceProvisioning',
    FilespaceProvisioned = 'filespaceProvisioned',
    FilespaceInitialized = 'filespaceInitialized',
    FilespaceDeleted = 'filespaceDeleted',
    FilespaceError = 'filespaceError',
    FilespaceLoaded = 'filespaceLoaded',

    FirstTimeDashboardEnter = 'firstTimeDashboardEnter',
    FirstFilespaceCreated = 'firstTimeCreateFilespace',
    FirstFilespaceProvisioned = 'firstFilespaceProvisioned',
    FirstFilespaceInitialized = 'firstTimeInitializeFilespace',

    DashboardEnter = 'dashboardEnter',
    DashboardExit = 'dashboardExit',

    TryInitializeFilespace = 'tryInitializeFilespace',
    FilespaceWizardEnter = 'filespaceWizardEnter',

    DomainCreated = 'domainCreated',
}


// WEBPACK FOOTER //
// ./src/webportal/services/WebportalEvent.ts